import React from 'react';
import './LoadingSkeleton.css';

/**
 * LoadingSkeleton Component
 * Skeleton placeholders for content that's loading
 * Shows a preview of the content structure while loading
 *
 * Props:
 * - type: 'card' | 'list' | 'text' | 'circle' | 'table' | 'player-card'
 * - count: Number of items to show (default: 1)
 * - height: Custom height for text skeleton (default: auto)
 */
const LoadingSkeleton = ({ type = 'card', count = 1, height = '20px' }) => {
  const items = Array.from({ length: count });

  const renderSkeleton = () => {
    switch (type) {
      case 'card':
        return items.map((_, i) => (
          <div key={i} className="skeleton-card">
            <div className="skeleton-image"></div>
            <div className="skeleton-content">
              <div className="skeleton-text skeleton-title"></div>
              <div className="skeleton-text skeleton-description"></div>
              <div className="skeleton-text skeleton-description" style={{ width: '80%' }}></div>
            </div>
          </div>
        ));

      case 'list':
        return items.map((_, i) => (
          <div key={i} className="skeleton-list-item">
            <div className="skeleton-circle"></div>
            <div className="skeleton-content" style={{ flex: 1 }}>
              <div className="skeleton-text skeleton-title"></div>
              <div className="skeleton-text skeleton-description"></div>
            </div>
          </div>
        ));

      case 'player-card':
        return items.map((_, i) => (
          <div key={i} className="skeleton-player-card">
            <div className="skeleton-header">
              <div className="skeleton-circle"></div>
              <div className="skeleton-content" style={{ flex: 1 }}>
                <div className="skeleton-text skeleton-title"></div>
                <div className="skeleton-text skeleton-description" style={{ width: '60%' }}></div>
              </div>
            </div>
            <div className="skeleton-content">
              <div className="skeleton-text skeleton-description"></div>
              <div className="skeleton-text skeleton-description"></div>
            </div>
          </div>
        ));

      case 'text':
        return items.map((_, i) => (
          <div key={i} style={{ marginBottom: '12px' }}>
            <div className="skeleton-text" style={{ height }}></div>
          </div>
        ));

      case 'circle':
        return items.map((_, i) => (
          <div key={i} className="skeleton-circle" style={{ marginRight: '12px', display: 'inline-block' }}></div>
        ));

      case 'table':
        return (
          <table className="skeleton-table">
            <thead>
              <tr>
                <th><div className="skeleton-text skeleton-title"></div></th>
                <th><div className="skeleton-text skeleton-title"></div></th>
                <th><div className="skeleton-text skeleton-title"></div></th>
              </tr>
            </thead>
            <tbody>
              {items.map((_, i) => (
                <tr key={i}>
                  <td><div className="skeleton-text skeleton-description"></div></td>
                  <td><div className="skeleton-text skeleton-description"></div></td>
                  <td><div className="skeleton-text skeleton-description"></div></td>
                </tr>
              ))}
            </tbody>
          </table>
        );

      default:
        return null;
    }
  };

  return <div className="loading-skeleton">{renderSkeleton()}</div>;
};

export default LoadingSkeleton;
